import { useMemo } from 'react'
import { EkoreLogo } from '../icons'

const ERROR_MESSAGES: Record<string, string> = {
  expired: 'Sessione di accesso scaduta. Riprova.',
  invalid: 'Accesso non riuscito. Riprova.',
  forbidden: 'Non hai accesso a questa applicazione. Contatta l’amministratore.',
}

export function LoginPage() {
  // Inspect ?auth_error=... that the server sets on failed callbacks.
  const errorMsg = useMemo<string | null>(() => {
    const code = new URLSearchParams(window.location.search).get('auth_error')
    if (!code) return null
    return ERROR_MESSAGES[code] ?? 'Accesso non riuscito. Riprova.'
  }, [])

  const onLogin = () => {
    window.location.assign('/api/auth/login')
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <header className="login-card__header">
          <EkoreLogo variant="color" height={32} />
        </header>
        <div className="login-card__body">
          <span className="eyebrow">Automation Control Tracking</span>
          <h1 className="login-card__title">Accedi</h1>
          <p className="login-card__sub">OWW Tradate · Pannello di controllo</p>

          {errorMsg && <div className="login-error" role="alert">{errorMsg}</div>}

          <button
            type="button"
            className="btn btn--primary login-card__submit"
            onClick={onLogin}
          >
            Continua con Ekore SSO
          </button>

          <p className="login-card__hint">
            Verrai reindirizzato al sistema di accesso Ekore (Keycloak).
          </p>
        </div>
      </div>
      <footer className="login-shell__footer">
        EKORE · AUTOMATION CONTROL TRACKING · OWW TRADATE
      </footer>
    </div>
  )
}
